import { RECENT_SEARCHES } from "./actionTypes";

export const setRecentSearch = (data) => (dispatch) => {
    dispatch({
        type: RECENT_SEARCHES,
        payload: data,
    });
};